import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { CtaLink } from '@/components/generals/cta-link'
import { Mark } from '@/components/generals/mark'
import { SectionLabel } from '@/components/generals/section-label'
import PrinciplesList from '@/components/sections/principles-list'

const AboutTeaser: FC = (): ReactNode => {
    return (
        <section id='about' aria-labelledby='about-title' data-nav-theme='light' className='relative overflow-hidden bg-cream text-charcoal'>
            <div className='mx-auto grid max-w-[1440px] gap-16 px-5 py-20 md:px-10 md:py-28 lg:grid-cols-12 lg:gap-10'>
                <div className='relative lg:col-span-6 lg:self-center'>
                    <div aria-hidden='true' className='absolute -left-5 top-16 h-[70%] w-[55%] bg-stone md:-left-10' />
                    <div aria-hidden='true' className='absolute -bottom-6 right-6 size-16 bg-coral md:size-20' data-parallax='8' />

                    <figure className='relative ml-[8%]'>
                        <div data-reveal-image className='relative aspect-[5/4] overflow-hidden bg-stone lg:aspect-[4/5] xl:aspect-[5/4]'>
                            <Image
                                src='/images/about/small-egos.png'
                                alt='Photographer shooting a model on a coral backdrop while the team reviews printed campaign proofs'
                                fill
                                sizes='(min-width: 1024px) 45vw, 92vw'
                                className='object-cover object-[40%_center]'
                            />
                        </div>
                        <figcaption className='mt-4 flex justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal/80'>
                            <span>Studio / Campaign shoot</span>
                            <span>04</span>
                        </figcaption>
                    </figure>
                </div>

                <div className='flex flex-col lg:col-span-6 lg:pl-8'>
                    <div data-reveal>
                        <SectionLabel>About BLITZ / 04</SectionLabel>
                        <h2 id='about-title' className='mt-6 font-heading type-section'>
                            <span className='block'>Small egos.</span>
                            <span className='block'>Big ideas.</span>
                            <span className='block'><Mark>Clear results.</Mark></span>
                        </h2>
                        <p className='mt-8 max-w-lg text-[17px] leading-relaxed text-charcoal/85'>
                            BLITZ is a creative marketing agency that combines strategic thinking, bold ideas, and performance-driven execution to help ambitious businesses grow.
                        </p>
                    </div>

                    <PrinciplesList className='mt-12' />

                    <div data-reveal className='mt-10'>
                        <CtaLink href='/about' variant='dark'>More about BLITZ</CtaLink>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutTeaser
